import {
  TrendingUp, PiggyBank, Receipt, ArrowLeftRight, Wallet, CalendarClock,
  Shuffle, Target, GraduationCap, Sailboat, Briefcase, ShieldCheck
} from "lucide-react";

export const services = [
  { id: "mf", title: "Mutual Fund Investment", desc: "Diversified equity & debt funds curated for long-term capital growth and inflation-beating returns.", Icon: TrendingUp },
  { id: "sip", title: "Systematic Investment Plan", desc: "Build wealth disciplined — invest fixed amounts monthly and harness the power of compounding.", Icon: PiggyBank },
  { id: "elss", title: "Tax Saving (ELSS)", desc: "Save up to ₹46,800 in tax under 80C while earning equity returns with a 3-year lock-in.", Icon: Receipt },
  { id: "stp", title: "Systematic Transfer Plan", desc: "Move lumpsum into equity in tranches. Rupee cost averaging without timing the market.", Icon: ArrowLeftRight },
  { id: "swp", title: "Systematic Withdrawal Plan", desc: "Generate a regular tax-efficient income stream from your accumulated mutual fund corpus.", Icon: Wallet },
  { id: "dtp", title: "Dividend Transfer Plan", desc: "Reinvest dividends from one scheme into another for accelerated portfolio compounding.", Icon: CalendarClock },
  { id: "switch", title: "Switch Facility", desc: "Rebalance between schemes within the same AMC in a single, cost-efficient transaction.", Icon: Shuffle },
  { id: "goal", title: "Goal Based Investment", desc: "Map life goals — house, car, vacation — to dedicated portfolios with tracked progress.", Icon: Target },
  { id: "child", title: "Child Education Planning", desc: "Future-proof your child's dreams with inflation-adjusted education corpus strategies.", Icon: GraduationCap },
  { id: "retire", title: "Retirement Planning", desc: "Engineer financial freedom with retirement corpus modelling and income-laddering plans.", Icon: Sailboat },
  { id: "wealth", title: "Wealth Management", desc: "End-to-end portfolio architecture, asset allocation and HNI advisory under one roof.", Icon: Briefcase },
  { id: "insurance", title: "Insurance & Protection", desc: "Term, health and ULIP solutions integrated into your overall financial blueprint.", Icon: ShieldCheck },
];

export const tickerStocks = [
  { sym: "NIFTY 50", price: 24812.55, chg: 0.42 },
  { sym: "SENSEX", price: 81384.21, chg: 0.38 },
  { sym: "BANKNIFTY", price: 52416.10, chg: -0.21 },
  { sym: "RELIANCE", price: 2914.40, chg: 1.12 },
  { sym: "TCS", price: 4087.65, chg: 0.55 },
  { sym: "HDFCBANK", price: 1689.20, chg: -0.34 },
  { sym: "INFY", price: 1842.75, chg: 0.78 },
  { sym: "ICICIBANK", price: 1234.50, chg: 1.05 },
  { sym: "SBIN", price: 821.30, chg: -0.62 },
  { sym: "BHARTIARTL", price: 1612.45, chg: 0.91 },
  { sym: "ITC", price: 487.20, chg: 0.15 },
  { sym: "LT", price: 3621.80, chg: 1.34 },
];

export const indexCards = [
  { name: "NIFTY 50", value: 24812.55, change: 104.20, pct: 0.42 },
  { name: "SENSEX", value: 81384.21, change: 308.05, pct: 0.38 },
  { name: "NIFTY BANK", value: 52416.10, change: -110.45, pct: -0.21 },
  { name: "NIFTY IT", value: 41382.50, change: 215.60, pct: 0.52 },
];

export const fundPerformance = [
  { name: "Axis Bluechip Fund", returns_1y: 18.4, returns_3y: 14.2, nav: 58.42 },
  { name: "Mirae Asset Large Cap", returns_1y: 17.1, returns_3y: 15.6, nav: 102.15 },
  { name: "Parag Parikh Flexi Cap", returns_1y: 22.7, returns_3y: 19.4, nav: 78.91 },
  { name: "SBI Small Cap Fund", returns_1y: 28.9, returns_3y: 23.1, nav: 145.32 },
  { name: "ICICI Pru Equity & Debt", returns_1y: 16.5, returns_3y: 13.8, nav: 312.40 },
];

export const whyUs = [
  { title: "Expert Financial Advice", desc: "AMFI-registered advisors with 15+ years of cumulative market wisdom." },
  { title: "Trusted Investment Solutions", desc: "Hand-picked schemes from 40+ AMCs vetted by independent research." },
  { title: "Tax Efficient Planning", desc: "80C, 80D, LTCG harvesting and tax-loss strategies built into every plan." },
  { title: "Long-Term Wealth Creation", desc: "Goal-mapped portfolios designed to outpace inflation and compound silently." },
  { title: "Secure Investments", desc: "Bank-grade encryption, AMFI compliance and SEBI-regulated execution." },
  { title: "Dedicated Relationship Manager", desc: "A single point of contact who knows your goals, family and milestones." },
];

export const stats = [
  { value: 1850, suffix: "Cr+", label: "Assets Under Advisory" },
  { value: 12400, suffix: "+", label: "Happy Clients" },
  { value: 15, suffix: "+", label: "Years of Experience" },
  { value: 8200, suffix: "+", label: "Active SIPs Managed" },
];

export const testimonials = [
  { name: "Yamini Patil", role: "Cardiologist, Mumbai", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MjcyNDc3Mnww&ixlib=rb-4.1.0&q=85", rating: 5, quote: "Wealthoo restructured my portfolio with surgical precision. My SIPs are mapped to my children's education in 2031 — and I sleep better at night." },
  { name: "Satyendra Kushwah", role: "Senior Engineer, Pune", img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MjcyNDc3Mnww&ixlib=rb-4.1.0&q=85", rating: 5, quote: "What I love is the transparency — no hidden brokerage, no agenda. They built me an ELSS ladder that saved ₹46,800 in tax this year." },
  { name: "Priya Deshmukh", role: "Startup Founder, Bangalore", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", rating: 5, quote: "From confused to confident in 90 days. The Wealthoo dashboard makes me feel like I have my own private wealth desk." },
  { name: "Rakesh Verma", role: "Retired Banker, Raipur", img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", rating: 5, quote: "Post-retirement SWP planning was a maze. Wealthoo built me a tax-efficient income ladder that pays out monthly like clockwork." },
];

export const blogs = [
  { id: 1, title: "5 SIP Mistakes That Quietly Destroy Long-Term Returns", category: "SIP Tips", readTime: "6 min", date: "Feb 12, 2026", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { id: 2, title: "Index vs Active Funds: The 2026 Verdict from Indian Data", category: "Mutual Fund Guide", readTime: "9 min", date: "Feb 08, 2026", img: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { id: 3, title: "Nifty at 25,000: Should You Book Profits or Stay Invested?", category: "Market Update", readTime: "5 min", date: "Feb 03, 2026", img: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { id: 4, title: "ELSS Decoded: How to Save ₹46,800 Tax With Equity Returns", category: "Tax Saving", readTime: "7 min", date: "Jan 28, 2026", img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { id: 5, title: "The ₹5 Crore Retirement Blueprint for Indian Professionals", category: "Retirement", readTime: "11 min", date: "Jan 21, 2026", img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { id: 6, title: "Small Cap Funds: When the Risk is Worth Taking", category: "Mutual Fund Guide", readTime: "8 min", date: "Jan 14, 2026", img: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

export const faqs = [
  { q: "What is a Mutual Fund Distributor?", a: "A Mutual Fund Distributor (MFD) is an AMFI-registered intermediary who helps investors choose, transact and track mutual fund schemes. We are paid a trail commission by the AMC — there is zero charge to you." },
  { q: "Is my money safe with Wealthoo?", a: "Your money never sits with us. Every transaction flows directly to the AMC (e.g., HDFC MF, SBI MF) via SEBI-regulated platforms like BSE Star MF. We only execute and advise — the asset is always in your name." },
  { q: "What is the minimum amount to start a SIP?", a: "Most quality mutual funds allow SIPs starting at just ₹500/month. We typically recommend a goal-based amount, but you can begin small and step-up over time." },
  { q: "How are returns taxed?", a: "Equity funds held over 1 year attract 10% LTCG (above ₹1 lakh annual). Debt funds are taxed at slab rate. ELSS gets 80C deduction plus equity LTCG treatment. Our advisors model this for you." },
  { q: "Can I withdraw my SIP anytime?", a: "Yes. Open-ended mutual funds (most SIPs) allow redemption any business day. Only ELSS has a mandatory 3-year lock-in per instalment." },
  { q: "How do you select funds for me?", a: "We screen across 1,200+ schemes using a 30-point matrix: rolling returns, alpha, beta, downside capture, expense ratio, AUM stability and fund manager tenure. Top quartile only." },
];

export const portfolio = {
  totalValue: 4845230,
  invested: 3200000,
  gain: 1645230,
  gainPct: 51.41,
  todayChg: 18420,
  todayPct: 0.38,
  allocation: [
    { name: "Equity Large Cap", value: 1820000, color: "#2563EB" },
    { name: "Equity Mid/Small", value: 1245000, color: "#60A5FA" },
    { name: "Hybrid", value: 612000, color: "#10B981" },
    { name: "Debt", value: 720000, color: "#F59E0B" },
    { name: "Gold ETF", value: 448230, color: "#A78BFA" },
  ],
  growth: [
    { month: "Mar", value: 3210000 },
    { month: "Apr", value: 3320000 },
    { month: "May", value: 3450000 },
    { month: "Jun", value: 3380000 },
    { month: "Jul", value: 3590000 },
    { month: "Aug", value: 3820000 },
    { month: "Sep", value: 4010000 },
    { month: "Oct", value: 4180000 },
    { month: "Nov", value: 4290000 },
    { month: "Dec", value: 4520000 },
    { month: "Jan", value: 4710000 },
    { month: "Feb", value: 4845230 },
  ],
  holdings: [
    { name: "Axis Bluechip Fund", units: 12450.32, nav: 58.42, value: 727380, pnl: 22.4 },
    { name: "Mirae Asset Large Cap", units: 6820.10, nav: 102.15, value: 696671, pnl: 19.8 },
    { name: "Parag Parikh Flexi Cap", units: 5240.85, nav: 78.91, value: 413567, pnl: 28.6 },
    { name: "SBI Small Cap Fund", units: 3120.55, nav: 145.32, value: 453380, pnl: 34.2 },
    { name: "ICICI Pru Equity & Debt", units: 1985.20, nav: 312.40, value: 620378, pnl: 15.4 },
  ],
  sips: [
    { fund: "Axis Bluechip Fund", amount: 15000, date: "5th every month", status: "Active", started: "Jun 2021" },
    { fund: "Parag Parikh Flexi Cap", amount: 10000, date: "10th every month", status: "Active", started: "Sep 2022" },
    { fund: "SBI Small Cap Fund", amount: 8000, date: "15th every month", status: "Active", started: "Jan 2023" },
    { fund: "Mirae Asset ELSS", amount: 12500, date: "20th every month", status: "Active", started: "Apr 2024" },
  ],
  transactions: [
    { date: "Feb 10, 2026", type: "Purchase", fund: "Axis Bluechip", amount: 15000, units: 256.74 },
    { date: "Feb 10, 2026", type: "Purchase", fund: "Parag Parikh Flexi Cap", amount: 10000, units: 126.73 },
    { date: "Jan 25, 2026", type: "Dividend", fund: "ICICI Pru Equity & Debt", amount: 4250, units: 0 },
    { date: "Jan 15, 2026", type: "Purchase", fund: "SBI Small Cap", amount: 8000, units: 55.05 },
    { date: "Jan 10, 2026", type: "Switch", fund: "Liquid → Bluechip", amount: 50000, units: 856.21 },
  ],
};

export const advisorClients = [
  { id: "WL-1042", name: "Rajesh Kapoor", aum: 8420000, sips: 4, kyc: "Verified", joined: "Mar 2019" },
  { id: "WL-1078", name: "Sneha Iyer", aum: 3120000, sips: 3, kyc: "Verified", joined: "Aug 2020" },
  { id: "WL-1124", name: "Vikram Singh", aum: 12480000, sips: 6, kyc: "Verified", joined: "Jan 2018" },
  { id: "WL-1198", name: "Anita Reddy", aum: 1890000, sips: 2, kyc: "Pending", joined: "Nov 2024" },
  { id: "WL-1245", name: "Mohammed Khan", aum: 5640000, sips: 5, kyc: "Verified", joined: "Feb 2022" },
  { id: "WL-1289", name: "Lakshmi Nair", aum: 2310000, sips: 3, kyc: "Verified", joined: "Jul 2023" },
  { id: "WL-1312", name: "Arjun Mehta", aum: 720000, sips: 1, kyc: "In Review", joined: "Jan 2026" },
];

export const commissionTrend = [
  { month: "Sep", value: 184000 },
  { month: "Oct", value: 212000 },
  { month: "Nov", value: 198000 },
  { month: "Dec", value: 245000 },
  { month: "Jan", value: 268000 },
  { month: "Feb", value: 291000 },
];
